__turbopack_context__.v({
  "rating-container": "rating-display-module-scss-module__TL_ANq__rating-container",
  "rating-count": "rating-display-module-scss-module__TL_ANq__rating-count",
  "rating-display-container": "rating-display-module-scss-module__TL_ANq__rating-display-container",
  "rating-display-container-tooltip": "rating-display-module-scss-module__TL_ANq__rating-display-container-tooltip",
  "star-rating-icon-color": "rating-display-module-scss-module__TL_ANq__star-rating-icon-color",
  "star-rating-icon-color-bordered": "rating-display-module-scss-module__TL_ANq__star-rating-icon-color-bordered",
});
